<template>
    <c-dialog ref="dialog" title="核销单详情" mode="slide" width="85vw" enable-flex  :button="false">
        <template #head>
            <div v-if="detailData.record_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.record_number}}</label>
                <c-state async tag dict="CHECK_ORDER_STATUS" :value="detailData.status"></c-state>
            </div>
        </template>

        <module>
            <module-col size="310">
                <c-detail class="m-detail-form">
                    <c-detail-item label="核销单号">
                        {{detailData.record_number}}
                    </c-detail-item>
                    <c-detail-item label="收款渠道">
                        <c-state tag async tag dict="CHECK_PAYMENT_CHANNEL" :value="detailData.check_payment_channel"></c-state>
                    </c-detail-item>
                    <c-detail-item label="核销状态">
                        <c-state tag async dict="CHECK_ORDER_STATUS" :value="detailData.status"></c-state>
                    </c-detail-item>
                    <c-detail-item label="核销金额">
                        ￥{{detailData.settlement_amount||0}}
                    </c-detail-item>
                    <c-detail-item label="背贴码数量">
                        {{detailData.product_count||0}}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <c-detail-item label="核销人">
                        {{detailData.check_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="核销时间">
                        {{detailData.check_date}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <!--商户确认单-->
                <module-tab name="商户确认单" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="confirmOrderListTable" :data="confirmOrderList" border :paging="false">
                            <c-table-column label="商家代码" width="100">
                                <template #default="{data}">
                                    <span>{{data.saas_id}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="商家名称" width="100">
                                <template #default="{data}">
                                    {{data.saas_name}}
                                </template>
                            </c-table-column>

                            <c-table-column label="结算金额" width="90">
                                <template #default="{data}">
                                    ￥{{detailData.settlement_amount||0}}
                                </template>
                            </c-table-column>

                            <c-table-column label="确认状态" width="90">
                                <template #default="{data}">
                                    <span v-if="data.status == 0" style="color: red">待确认</span>
                                    <span v-else-if="data.status == 1" style="color: green">已确认</span>
                                    <span v-else>--</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="确认时间" width="140">
                                <template #default="{data}">
                                    {{data.confirm_date||'-'}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
                <!--核销商品明细-->
                <module-tab name="核销商品明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="productList">
                            <c-table-column
                                    label="商品信息"
                                    width="230"
                            >
                                <template #default="{data}">
                                    {{getProductText(data)}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="produce_unique_code"
                                    label="背贴码"
                                    width="150"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="order_no"
                                    label="小黑订单号"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column label="销售货款" width="80">
                                <template #default="{data}">
                                    <span style="color: green">￥{{data.check_product_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="退款金额" width="80">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_return_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="补差金额" width="80">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_supplement_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="结算金额" width="80">
                                <template #default="{data}">
                                    <strong v-if="data.check_receipt_money > 0" style="color: green">￥{{data.check_receipt_money||0}}</strong>
                                    <strong v-if="data.check_receipt_money <= 0" style="color: red">￥{{data.check_receipt_money||0}}</strong>
                                </template>
                            </c-table-column>
                            <c-table-column
                                    name="out_order_number"
                                    label="三方单号"
                                    width="150"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="third_number"
                                    label="三方流水号"
                                    width="150"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="receipt_date"
                                    label="收款日期"
                                    width="140"
                            >
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
        <template #button>
            <c-button color="main" size="dialog" v-if="auth('b_xiaohei_order_check_audit') && detailData.status == 0" :disabled="!checkAble"
                       icon="tf-accept" @click="checkOrder()">确认核销</c-button>
        </template>
    </c-dialog>
</template>

<script>

export default {
    name: 'orderCheckDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            confirmOrderList:[],
            check_order_id:0,
            checkAble:true
        }
    },

    computed: {
    },

    methods: {
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url: '/sale/check/detail',
                data: {
                    id: this.check_order_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.check_order_detail;
                    this.confirmOrderList = data.confirm_order_list||[];
                    this.searchProductHandle();
                }
            });
        },
        /********搜索************/
        searchProductHandle(data){
            if (!data){
                data = {};
            }
            data.check_order_id = this.check_order_id;
            this.$refs.productList.load({
                url: '/sale/check/product/list',
                data
            });
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        open(data) {
            this.check_order_id = data.id;
            this.detail();
            this.$refs.dialog.open();
        },
        /**
         * 核销
         */
        checkOrder(){
            this.$confirm({
                title: '变更核销单状态',
                message: '是否将核销单【'+this.detailData.record_number+'】修改为“已核销”',
                resolve: () => {
                    this.checkAble = false;
                    this.request({
                        url: '/sale/check/updateStatus',
                        data: {
                            id:this.detailData.id,
                            status:1
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                message: '核销完成'
                            });
                            //回调
                            this.$emit('resolve');
                            //关闭页面
                            this.$refs.dialog.close();
                        }
                    })
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>